<template>
    <div class="modal bookable-slot" tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="card border-0">
                    <div class="card-body pb-sm-5 pb-5">
                        <div class="row">
                            <div class="col-10 offset-1">
                                <div class="row mb-4 mt-4 mt-sm-5">
                                    <div class="col-12">
                                        <h2 class="text-2xl" v-html="$t('<strong>Fullfør</strong><br>bestillingen')"></h2>
                                        <p class="text-sm text-elev-blue-dim" v-if="!autoApproveBooking">{{ $t('Husk at trafikkskolen må bekrefte bookingen før den er gyldig.') }}</p>
                                    </div>
                                </div>
                                <div class="row mb-3">
                                    <div class="col-2 col-sm-1">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="#7C889B">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                        </svg>
                                    </div>
                                    <div class="col-10 col-sm-11 text-xl fw-bold">
                                        {{ slotData.date }}
                                    </div>
                                </div>
                                <div class="row mb-3">
                                    <div class="col-2 col-sm-1">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="#7C889B">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                    </div>
                                    <div class="col-10 col-sm-11 text-xl">
                                        <strong>{{ slotData.start_time }}</strong> – {{ slotEndTime }}
                                    </div>
                                </div>
                                <div class="row mb-3" v-if="days && days.length > 1">
                                    <div class="col-2 col-sm-1">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="#7C889B">
                                            <path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                                        </svg>
                                    </div>
                                    <div class="col-10 col-sm-11">
                                        <span class="text-xl fw-bold">{{ $t('{count} dager', {count: days.length}) }}:</span>
                                        <div class="my-2">
                                            <span v-for="(day,i) in days" class="text-sm">
                                                <span class="fw-bold">{{i+1}}.</span> <span class="text-elev-blue-dim">{{ day }}</span>
                                                <br>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mb-3" v-if="isLesson">
                                    <div class="col-2 col-sm-1">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="#7C889B">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                        </svg>
                                    </div>
                                    <div class="col-10 col-sm-11 text-xl fw-bold">
                                        {{ slotData.teacher_name }}
                                    </div>
                                </div>

                                <div class="row mb-3" v-if="!isOptima || remainingPackageQuantity < slotData.quantity">
                                    <div class="col-2 col-sm-1">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="#7C889B">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                                        </svg>
                                    </div>
                                    <div class="col-10 col-sm-11 text-xl fw-bold">
                                        {{ slotData.price }}
                                    </div>
                                </div>

                                <div class="row mb-3" v-if="isOptima && slotData.unused_package_quantity >= slotData.quantity">
                                    <div class="col-2 col-sm-1">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="#7C889B">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                                        </svg>
                                    </div>
                                    <div class="col-10 col-sm-11 text-xl fw-bold">
                                        {{ $t('Inkludert i pakke') }}
                                    </div>
                                </div>

                                <div class="row mb-3">
                                    <div class="col-2 col-sm-1">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="#7C889B">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                                        </svg>
                                    </div>
                                    <div class="col-10 col-sm-11 text-xl fw-bold" v-if="slotData.product_id === 113">
                                        {{ $t('Kjøretime klasse {className}', { className: slotData.class_name }) }}
                                    </div>
                                    <div class="col-10 col-sm-11 text-xl fw-bold" v-if="slotData.product_id !== 113">
                                        {{ slotData.label }} - {{ slotData.class_name }}
                                    </div>
                                </div>

                                <div class="row mb-3" v-if="slotData.location_text">
                                    <div class="col-2 col-sm-1">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="#7C889B" class="w-6 h-6">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
                                        </svg>
                                    </div>
                                    <div class="col-10 col-sm-11 text-xl fw-bold">
                                        {{ slotData.location_text }}
                                    </div>
                                </div>

                                <div class="row mb-3" v-if="isCourse && interpreterAvailable">
                                    <div class="col-2 col-sm-1">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="#7C889B" stroke-width="2">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                                        </svg>

                                    </div>
                                    <div class="col-10 col-sm-11 text-xl fw-bold">
                                        <div class="form-check">
                                            <input class="form-check-input mt-2" type="checkbox" name="with_interpreter" id="with_interpreter" value="1" v-model="with_interpreter">
                                            <label class="form-check-label fw-bold cursor-pointer" for="with_interpreter">
                                                {{ $t('Med tolk') }}
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="row" v-if="!isOptima" :class="{'mb-5': !terms, 'mb-3': terms}">
                                    <div class="col-2 col-sm-1">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="#7C889B">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                                        </svg>

                                    </div>
                                    <div class="col-10 col-sm-11 text-xl fw-bold">
                                        <p v-if="commentHeader" class="m-0 text-xl fw-bold">{{ commentHeader }}</p>
                                        <input type="text" class="form-control" :placeholder="$t('Har du en kommentar?')" v-model="comment">
                                    </div>
                                </div>

                                <div class="row mb-5" v-if="terms">
                                    <div class="col-2 col-sm-1">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="#7C889B">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                                        </svg>
                                    </div>
                                    <div class="col-10 col-sm-11">
                                        <p class="m-0 fw-bold text-xl">{{ $t('Bestillingsvilkår') }}</p>
                                        <p class="m-0"><span v-html="terms.split('\n').join('<br />')"></span></p>
                                    </div>
                                </div>

                                <div class="row mb-5" v-if="hasBookingTerms">
                                    <div class="col-2 col-sm-1">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="#7C889B">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                                        </svg>
                                    </div>
                                    <div class="col-10 col-sm-11 text-xl fw-bold">
                                        <a href="/booking-terms" target="_blank" class="text-decoration-underline text-body">{{ $t("Fullstendige kjøpsvilkår") }}</a>
                                    </div>
                                </div>

                                <div class="row mt-3" v-show="success !== null">
                                    <div class="col-12 text-center">
                                        <div class="alert" :class="{ 'alert-danger': success === false, 'alert-success': success === true}">
                                            <p class="m-0" v-html="message"></p>
                                        </div>
                                    </div>
                                </div>

                                <!-- Buttons -->
                                <div class="row mb-3">
                                    <div class="col-12 text-center">
                                        <button class="btn btn-elev-blue btn-block py-3 fw-bold" @click.prevent="submitBookingRequest" :disabled="isRunningBookingRequest || isContact">
                                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-show="isRunningBookingRequest"></span>
                                            {{ $t('Send bestilling') }}
                                        </button>
                                        <div v-if="isContact" class="my-2 text-sm fw-bold text-center col-12">{{ $t('Kjøretimer kan kun bookes av eleven selv') }}</div>
                                    </div>
                                </div>
                                <div>
                                    <a href="#" class="text-elev-blue-dim text-decoration-none btn-block btn btn-link font-weight-bolder" @click.prevent="navigateBack">{{ $t('Tilbake') }}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import Store from '../../state/calendarStore'

const props = defineProps(['slotData', 'date', 'autoApproveBooking', 'terms']);

// Reactive state
const comment = ref('')
const with_interpreter = ref(false)

// Computed
const slotEndTime = computed(() => 
    props.slotData.end_time_by_product_duration 
        ? props.slotData.end_time_by_product_duration 
        : props.slotData.end_time
)

const isRunningBookingRequest = computed(() => Store.state.isRunningBookingRequest.value)
const success = computed(() => Store.state.requestSuccess.value)
const message = computed(() => Store.state.responseMessage.value)
const label = computed(() => props.slotData.label.toLowerCase())
const isContact = computed(() => Store.state.isContact.value)
const isCourse = computed(() => [3,35].includes(props.slotData.product_type))
const isLesson = computed(() => props.slotData.product_type === 1)
const hasBookingTerms = computed(() => Store.state.hasBookingTerms.value)
const days = computed(() => props.slotData.days)
const interpreterAvailable = computed(() => props.slotData.free_interpreter_slots > 0)
const isOptima = computed(() => window.isOptima)
const remainingPackageQuantity = computed(() => Store.getRemainingPackageQuantity())
const commentHeader = computed(() => Store.getCommentHeader())

// Methods
function navigateBack() {
    Store.selectSlot(false)
}

function submitBookingRequest() {
    if (isContact.value || isRunningBookingRequest.value) {
        return
    }

    Store.requestBooking({
        comment: comment.value,
        start_time: props.slotData.start_time,
        end_time: props.slotData.end_time,
        date: props.date,
        teacher_id: props.slotData.teacher_id,
        product_id: props.slotData.product_id,
        course_id: props.slotData.course_id,
        class_id: props.slotData.class_id,
        with_interpreter: with_interpreter.value,
    })
}

// Event handlers
function onEscape(e) {
    if (e.keyCode === 27) {
        navigateBack()
    }
}

// Lifecycle hooks
onMounted(() => {
    document.addEventListener('keydown', onEscape)
})

onUnmounted(() => {
    document.removeEventListener('keydown', onEscape)
})
</script>
